// extracted by mini-css-extract-plugin
export default {"wrapper":"g2gbAQ7HDwyIzEo_m269","titleWrapper":"vmsZsnpMs7aDFTS6XVjU","titlesContainer":"R5fOsdAkg0ZgiYwevdfF","actions":"TnOGQXLVoEw3CS5c_2yw","newTeamBtn":"NZGzBvb0OOpOrcMa6CU_"};